import CountryUtil from "../uidispatcherapi/CountryUtil";
import LocaleUtil from "../uidispatcherapi/LocaleUtil";
import { AppUrlUtil } from "../utils/AppUrlUtil";
import "intersection-observer";
import { InView } from "react-intersection-observer";
import Tracking from "../uidispatcherapi/Tracking";
import { useEffect, useRef } from "react";

type NextCMSFooterProps = {
	isNoFooter: boolean;
	isReduced: boolean;
	location: Location;
};

export const NextCMSFooter = ({ isNoFooter, isReduced, location }: NextCMSFooterProps) => {
	const componentRef = useRef<HTMLElement>(null);
	const eventTypeLanguageSwitch = "cms:language-switcher";

	const handleLanguageSwitch = event => {
		const url = AppUrlUtil.updateQueryStringParameter(window.location.href, "lang", event.language);
		location.href = url;
	};

	const clickHandler = () => {
		Tracking.trackFooterClick();
	};

	const scrollHandler = inView => {
		if (inView) {
			Tracking.trackFooterComponentView();
		}
	};

	const addListeners = () => {
		componentRef?.current?.addEventListener(eventTypeLanguageSwitch, handleLanguageSwitch);
	};

	const addScriptAndListeners = () => {
		const siteCoreFooterUrl =
			CountryUtil.getOptionalConfig()?.siteCoreUrl ?? "https://authors-dev2-sc.metro.md/data/apps/metro";
		const script = document.createElement("script");
		const locale = LocaleUtil.getLocale();

		if (locale) {
			script.src =
				siteCoreFooterUrl +
				"?sc_device=webcomponent&components=site%20footer%20container,site%20footer%20container%20minimal,global%20footer&sc_lang=" +
				locale;
		} else {
			script.src =
				siteCoreFooterUrl +
				"?sc_device=webcomponent&components=site%20footer%20container,site%20footer%20container%20minimal,global%20footer";
		}

		if (document.head != null) {
			document.head.appendChild(script);
		}

		addListeners();
		Tracking.trackFooterImpression();
	};

	useEffect(() => {
		addScriptAndListeners();
	}, []);

	if (isNoFooter) {
		return null;
	}

	if (isReduced) {
		return (
			<InView
				as="div"
				threshold={0.5}
				delay={500}
				trackVisibility
				triggerOnce
				onChange={inView => scrollHandler(inView)}>
				<div className="footer-click-container" onClick={() => clickHandler()}>
					<cms-site-footer-container-minimal ref={componentRef} />
					<cms-global-footer />
				</div>
			</InView>
		);
	}

	return (
		<InView
			as="div"
			delay={500}
			trackVisibility
			threshold={0.5}
			triggerOnce
			onChange={inView => scrollHandler(inView)}>
			<div className="footer-click-container" onClick={() => clickHandler()}>
				<cms-site-footer-container ref={componentRef} />
				<cms-global-footer />
			</div>
		</InView>
	);
};
